import React from 'react';
import { TdsLoadingSpinner } from '@trv-tds/react';

import './styles.scss';

const spinTransition = {
    loop: Infinity,
    duration: 1,
    ease: 'linear'
};

export default function Loader() {
    return (
        <div className="spinner">
            <div className="big-loader-center tds-flex-column">
                <TdsLoadingSpinner
                    animation="semicircles"
                    animate={{ rotate: 360 }}
                    transition={spinTransition}
                />
            </div>
        </div>
    );
}
